import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { RadioGroup } from 'edenred-ui';

import { createRules, FormFields, InvoicingMethod } from '@epi-forms/helpers';
import { required } from '@epi-helpers/formHelpers/validators';
import { InvoicingMethodRadioProps } from '@epi-models/forms/Controls';

import { EmailInvoiceField } from './EmailInvoiceField';
import { EInvoiceField } from './EInvoiceField';

export function InvoicingMethodRadio({
  readOnly = false,
  onChange
}: InvoicingMethodRadioProps) {
  const name = FormFields.InvoicingMethod;
  const { control } = useFormContext();
  const validators = [required];
  const rules = createRules(validators);

  const {
    field: { value, onChange: setValue }
  } = useController({
    name,
    control,
    rules
  });

  const onRadioChange = event => {
    const newValue = event.currentTarget.value;

    setValue(newValue);

    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <RadioGroup value={value} onChange={onRadioChange} id={name}>
      <EmailInvoiceField
        readOnly={readOnly}
        isActive={value === InvoicingMethod.Email}
      />
      <EInvoiceField
        readOnly={readOnly}
        isActive={value === InvoicingMethod.EInvoice}
      />
    </RadioGroup>
  );
}
